import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { advChannels, isablePoster, delPoster } from "@/api/Administration/advertisingChannels";
import adChannels from "./components/adChannels";
export default {
  name: "advertisement",
  components: {
    adChannels: adChannels
  },
  data: function data() {
    return {
      tableData: [],
      adChannels: false,
      total: 0,
      page: 1,
      showing: false,
      searchData: {
        page: 1,
        page_size: 10
      }
    };
  },
  created: function created() {
    this.getData(1);
  },
  methods: {
    handleSource: function handleSource(id) {
      var _this = this;

      this.adChannels = true;
      this.showing = true;
      this.$nextTick(function () {
        _this.$refs.adChannels.init(id);
      });
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.getData(1);
    },
    getData: function getData(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.searchData.page = e;
                advChannels(_this2.searchData).then(function (res) {
                  if (res.status == 200) {
                    if (!res.data.data.length && e > 1) {
                      _this2.getData(e - 1);
                    } else {
                      _this2.tableData = res.data.data || [];
                      _this2.total = res.data.total || 0;
                    }
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleDisable: function handleDisable(id) {
      var _this3 = this;

      isablePoster({
        id: id
      }).then(function (res) {
        if (res.status == 200) {
          Message({
            message: res.message,
            type: "success"
          });

          _this3.getData(_this3.searchData.page);
        } else {
          Message({
            message: res.message,
            type: "warning"
          });
        }
      });
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleDelete: function handleDelete(id) {
      var _this4 = this;

      this.$confirm(this.$t('confirmDeleteData'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                delPoster({
                  id: id
                }).then(function (res) {
                  _this4.getData(_this4.searchData.page);

                  _this4.$message({
                    type: "success",
                    message: res.message
                  });
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};